require('angular');
require('ngRoute');
require('ngRaven');
require('ngResource');
require('ngMd5');

require('bootstrap-webpack');
require('angular-cookies');

window.Notify = require('notifyjs');

window.moment = require('moment');
require('momentTz');

require('angular-intercom');

require('rtc-screenshare');
// require('getusermedia');
require('quickconnect');
require('ngDraggableUi');

window.libphone = require('libphonenumber-js');


/*****************
 ** WEBPACK FOOTER
 ** ./app/vendor.js
 ** module id = 0
 ** module chunks = 1
 **/